import { FC, useState } from 'react';
import { useRecoilState } from 'recoil';
import { TextField } from '@mui/material';
import { searchTextAtomFamily } from './filterState';

type Props = {
  list: any[];
  renderElement: (item: any) => JSX.Element;
  elementsContainerStyle?: any;
  pageKey?: string;
}

const SearchableListWithRecoil: FC<Props & { pageKey: string }> = ({ list, renderElement, elementsContainerStyle={}, pageKey }) => {
  const [searchArgument, setSearchArgument] = useRecoilState(searchTextAtomFamily(pageKey));

  const filteredElements = list?.filter(elem =>
    Object.keys(elem).map(k => elem[k]).join(',')
    .toLocaleLowerCase().includes(searchArgument.toLocaleLowerCase()));

  return (
    <>
      <TextField
        label="Search"
        variant="outlined"
        fullWidth
        sx={{ marginTop: '1em' }}
        value={searchArgument}
        onChange={e => setSearchArgument(e.target.value)}
      />
      <div style={{...elementsContainerStyle}}>
        {filteredElements?.map((elem: any) => renderElement(elem))}
      </div>
    </>
  );
};

const SearchableListLocal: FC<Props> = ({ list, renderElement, elementsContainerStyle={} }) => {
  const [searchArgument, setSearchArgument] = useState<string>('');

  const filteredElements = list?.filter(elem =>
    Object.keys(elem).map(k => elem[k]).join(',')
    .toLocaleLowerCase().includes(searchArgument.toLocaleLowerCase()));

  return (
    <>
      <TextField
        label="Search"
        variant="outlined"
        fullWidth
        sx={{ marginTop: '1em' }}
        onChange={e => setSearchArgument(e.target.value)}
      />
      <div style={{...elementsContainerStyle}}>
        {filteredElements?.map((elem: any) => renderElement(elem))}
      </div>
    </>
  );
};

export const SearchableList: FC<Props> = (props) => {
  if (props.pageKey) {
    return <SearchableListWithRecoil {...props} pageKey={props.pageKey} />;
  }
  return <SearchableListLocal {...props} />;
}